export default {
    text_1: "Recenze klientů - DOFFERO®",
    text_2: "Recenze klientů",
    text_3: "Recenze tvých klientů",
    text_4: "Přidej si recenze svých klientů. Ty se pak mohou zobrazovat v tvých nabídkách, pokud si to nastavíš při tvorbě nabídky.",
    text_5: "Úprava recenze",
    text_6: "Tvorba recenze",
    text_7: "Tvoje recenze",
    text_8: "Klient",
    text_9: "Jméno osoby",
    text_10: "Text recenze",
    text_11: "Uložit",
    text_12: "Vytvořit",
    text_13: "Ukončit",
    text_14: "Recenze byla vytvořena",
    text_15: "Recenze byla upravena",
    text_16: "#ID",
    text_17: "Klient",
    text_18: "Osoba",
    text_19: "Text",
    text_20: "Akce",
    text_21: "Aktivovat",
    text_22: "Deaktivovat",
    text_23: "Upravit recenzi",
    text_24: "Smazat recenzi",
    text_25: "Recenze byla smazána",
    text_26: "Recenze byla deaktivována",
    text_27: "Recenze byla aktivována"
}
